// @ts-nocheck
import FilteredConfigurableReducer, {
    StoreFilteredConfigurableActions,
} from "@store/Framework/Store/Store/Data/FilteredConfigurable/FilteredConfigurableReducer";
import MyWarehouseReducer, {
    StoreMyWarehouseActions,
} from "@store/Framework/Store/Store/Data/MyWarehouse/MyWarehouseReducer";
import PartFinderReducer, {
    StorePartFinderActions,
} from "@store/Framework/Store/Store/Data/PartFinder/PartFinderReducer";
import PickupWarehouseReducer, {
    StorePickupWarehouseActions,
} from "@store/Framework/Store/Store/Data/PickupWarehouses/PickupWarehousesReducer";
import ProductCatalogsReducer, {
    StoreProductCatalogsActions,
} from "@store/Framework/Store/Store/Data/ProductCatalogs/ProductCatalogsReducer";
import { combineReducers } from "redux";

const dataReducers = {
    mywarehouse: MyWarehouseReducer,
    filteredconfigurable: FilteredConfigurableReducer,
    pickupWarehouse: PickupWarehouseReducer,
    productCatalogs: ProductCatalogsReducer,
    partFinder: PartFinderReducer,
};

export type StoreDataActions =
    | StoreFilteredConfigurableActions
    | StoreMyWarehouseActions
    | StorePickupWarehouseActions
    | StoreProductCatalogsActions
    | StorePartFinderActions;
export default combineReducers(dataReducers);
